import React from 'react';
import AdvanceBillReportsHeader from './AdvanceBillReportsHeader';
import AdvanceBillReportsContent from './AdvanceBillReportsContent';

const AdvanceBillReportsCEO = () => {
    return (
        <>
            <AdvanceBillReportsHeader />
            <AdvanceBillReportsContent />
        </>
    );
};

export default AdvanceBillReportsCEO;
